import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-777a4980"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "landingpage-background w-screen h-screen" }
const _hoisted_2 = {
  class: "flex flex-col justify-between",
  style: {"height":"1020px"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs text-gray-500" }, "Zuwegung Mast > Geländebeschaffenheit (Gefälle/Ausholzung/Rodung/Zuwegung)", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xl md:text-xl font-bold" }, "Zuwegung Mast", -1))
const _hoisted_5 = { class: "content h-full max-h-full" }
const _hoisted_6 = { class: "mt-0 grid grid-cols-8 justify-items-stretch items-center gap-y-3" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-lg md:text-lg col-span-8" }, "Geländebeschaffenheit", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-span-2 text-sm font-bold border-solid rounded-md whiteYellowBorderColor" }, "Frage", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-bold col-span-3 border-solid rounded-md whiteYellowBorderColor" }, "Beschreibung/Eingabewerte", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-span-2 text-sm font-bold border-solid rounded-md whiteYellowBorderColor" }, "Weitere Eingaben", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-span- text-sm font-bold border-solid rounded-md whiteYellowBorderColor" }, "Bewertung", -1))
const _hoisted_12 = { class: "text-xs text-gray-500 col-span-5" }
const _hoisted_13 = { class: "text-xs text-gray-500 col-span-3" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs" }, "Bereich:", -1))
const _hoisted_15 = { class: "text-xs text-gray-500" }
const _hoisted_16 = { class: "text-xs text-gray-500 col-span-3" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs" }, "Anzahl Bäume:", -1))
const _hoisted_18 = { class: "text-xs text-gray-500" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Zuwegung Wegeart", -1))
const _hoisted_20 = { class: "text-xs text-gray-500 col-span-5" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Zuwegung Länge", -1))
const _hoisted_22 = { class: "text-xs text-gray-500 col-span-5" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Zuwegung Breite von-bis", -1))
const _hoisted_24 = { class: "text-xs text-gray-500 col-span-3" }
const _hoisted_25 = { class: "text-xs text-gray-500 col-span-2" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Zuwegung Höhe", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs" }, " Start ", -1))
const _hoisted_28 = { class: "text-xs text-gray-500 col-span-2" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs" }, " Ende ", -1))
const _hoisted_30 = { class: "text-xs text-gray-500 col-span-2" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, null, -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs" }, " Unterschied ", -1))
const _hoisted_33 = { class: "text-xs text-gray-500 col-span-2" }
const _hoisted_34 = { class: "text-xs text-gray-500 col-span-2" }
const _hoisted_35 = { class: "landingpage-background w-screen h-screen" }
const _hoisted_36 = {
  class: "flex flex-col justify-between",
  style: {"height":"1020px"}
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs text-gray-500" }, "Zuwegung Mast > Geländebeschaffenheit (Beschränkung/Beschaffenheit/Ringverkehr/Ausweichflächen/Zufahrt/Sonstiges)", -1))
const _hoisted_38 = { class: "content h-full max-h-full" }
const _hoisted_39 = { class: "mt-0 grid grid-cols-8 justify-items-stretch items-center gap-y-3" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-lg md:text-lg col-span-8" }, "Geländebeschaffenheit - Fortsetzung", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-span-2 text-sm font-bold border-solid rounded-md whiteYellowBorderColor" }, "Frage", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-bold col-span-3 border-solid rounded-md whiteYellowBorderColor" }, "Beschreibung/Eingabewerte", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-span-2 text-sm font-bold border-solid rounded-md whiteYellowBorderColor" }, "Weitere Eingaben", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-span- text-sm font-bold border-solid rounded-md whiteYellowBorderColor" }, "Bewertung", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-1" }, "Art:", -1))
const _hoisted_46 = { class: "text-xs text-gray-500 col-span-2" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs text-xs" }, "Gewicht:", -1))
const _hoisted_48 = { class: "text-xs text-gray-500" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-span-5" }, null, -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs text-xs" }, "Höhe:", -1))
const _hoisted_51 = { class: "text-xs text-gray-500" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Beschaffenheit:", -1))
const _hoisted_53 = { class: "text-xs text-gray-500 col-span-5" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Ringverkehr:", -1))
const _hoisted_55 = { class: "text-xs text-gray-500 col-span-3" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs" }, "Möglich?", -1))
const _hoisted_57 = { class: "text-xs text-gray-500" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Ausweichflächen:", -1))
const _hoisted_59 = { class: "text-xs col-span-2" }
const _hoisted_60 = { class: "text-xs text-gray-500" }
const _hoisted_61 = { class: "text-xs text-gray-500 col-span-3" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Alternative Zufahrt:", -1))
const _hoisted_63 = { class: "text-xs text-gray-500 col-span-3" }
const _hoisted_64 = { class: "text-xs text-gray-500 col-span-2" }
const _hoisted_65 = { class: "text-xs text-gray-500 col-span-5" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-lg md:text-lg" }, "Bauwerke", -1))
const _hoisted_67 = { key: 0 }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid grid-cols-8 justify-items-stretch items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-span-2 text-sm font-bold border-solid rounded-md whiteYellowBorderColor" }, "Frage"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-bold col-span-3 border-solid rounded-md whiteYellowBorderColor" }, "Beschreibung/Eingabewerte"),
  /*#__PURE__*/_createElementVNode("div", { class: "col-span-2 text-sm font-bold border-solid rounded-md whiteYellowBorderColor" }, "Weitere Eingaben"),
  /*#__PURE__*/_createElementVNode("div", { class: "col-span- text-sm font-bold border-solid rounded-md whiteYellowBorderColor" }, "Bewertung")
], -1))
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2 ml-2 mt-2" }, "Bauwerke:", -1))
const _hoisted_70 = { class: "text-xs col-span-3 text-gray-500" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs md:text-xs" }, "Tragfähig:", -1))
const _hoisted_72 = { class: "text-xs text-gray-500 capitalize" }
const _hoisted_73 = { class: "justify-self-end row-span-2" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-span-2" }, null, -1))
const _hoisted_75 = { class: "text-xs col-span-3 text-gray-500" }
const _hoisted_76 = { key: 1 }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "justify-center items-center col-span-8",
  style: {"background-color":"rgb(235, 239, 240)","border-style":"solid","border-color":"rgb(235, 239, 240) rgb(235, 239, 240)\n                    rgb(235, 239, 240) rgb(235, 239, 240)","border-radius":"5px"}
}, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-center" }, "Keine Bauwerke aufgenommen")
], -1))
const _hoisted_78 = [
  _hoisted_77
]
const _hoisted_79 = { class: "landingpage-background w-screen h-screen" }
const _hoisted_80 = {
  class: "flex flex-col justify-between",
  style: {"height":"1020px"}
}
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs text-gray-500" }, "Zuwegung Mast > Geländebeschaffenheit (Gräben)", -1))
const _hoisted_82 = { class: "content h-full max-h-full" }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-4 text-lg md:text-lg" }, "Gräben", -1))
const _hoisted_84 = { key: 0 }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid grid-cols-8 justify-items-stretch items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-span-2 text-sm font-bold border-solid rounded-md whiteYellowBorderColor" }, "Frage"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-bold col-span-3 border-solid rounded-md whiteYellowBorderColor" }, "Beschreibung/Eingabewerte"),
  /*#__PURE__*/_createElementVNode("div", { class: "col-span-2 text-sm font-bold border-solid rounded-md whiteYellowBorderColor" }, "Weitere Eingaben"),
  /*#__PURE__*/_createElementVNode("div", { class: "col-span- text-sm font-bold border-solid rounded-md whiteYellowBorderColor" }, "Bewertung")
], -1))
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2 ml-2" }, "Art: ", -1))
const _hoisted_87 = { class: "text-xs col-span-3 capitalize" }
const _hoisted_88 = { class: "text-xs text-gray-500 col-span-2" }
const _hoisted_89 = { class: "justify-self-end row-span-2" }
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-span-2 text-xs ml-2" }, "Abstand", -1))
const _hoisted_91 = { class: "text-xs text-gray-500 col-span-3" }
const _hoisted_92 = { class: "text-xs text-gray-500 col-span-3" }
const _hoisted_93 = { key: 1 }
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-2 grid grid-cols-8 justify-items-stretch items-center" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "justify-center items-center col-span-8",
    style: {"background-color":"rgb(235, 239, 240)","border-style":"solid","border-color":"rgb(235, 239, 240) rgb(235, 239, 240)\n                    rgb(235, 239, 240) rgb(235, 239, 240)","border-radius":"5px"}
  }, [
    /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-center" }, "Keine Grabenquerungen aufgenommen")
  ])
], -1))
const _hoisted_95 = [
  _hoisted_94
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tng_header = _resolveComponent("tng-header")!
  const _component_is_vorhanden_char_and_label = _resolveComponent("is-vorhanden-char-and-label")!
  const _component_bewertung_chip = _resolveComponent("bewertung-chip")!
  const _component_oneto_five_image_div = _resolveComponent("oneto-five-image-div")!
  const _component_be_footer = _resolveComponent("be-footer")!
  const _component_pdf_a4_page = _resolveComponent("pdf-a4-page")!
  const _component_PdfChip = _resolveComponent("PdfChip")!
  const _component_pdf_a_4_page = _resolveComponent("pdf-a-4-page")!
  const _component_Oekologie = _resolveComponent("Oekologie")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_pdf_a4_page, {
      "no-margin": "",
      "pdf-key": _ctx.lang
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_tng_header, {
              ba: _ctx.ba,
              immobilie: _ctx.immobilie,
              lang: _ctx.lang
            }, null, 8, ["ba", "immobilie", "lang"]),
            _hoisted_3,
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _hoisted_8,
                _hoisted_9,
                _hoisted_10,
                _hoisted_11,
                _createVNode(_component_is_vorhanden_char_and_label, {
                  ba: _ctx.ba,
                  fragesPath: "tng-be-flaechen.zuwegung-mast-tab.gefaelle.gefaelle-vorhanden",
                  label: "Gefälle",
                  class: "col-span-2"
                }, null, 8, ["ba"]),
                _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.useIdentifierFrageFinder(_ctx.ba, 'tng-be-flaechen.zuwegung-mast-tab.gefaelle.gefaelle-beschreibung')?.['eingabeText']), 1),
                _createVNode(_component_bewertung_chip, {
                  fragesPath: "tng-be-flaechen.zuwegung-mast-tab.gefaelle.gefaelle-bewertung",
                  ba: _ctx.ba,
                  immobilie: _ctx.immobilie,
                  lang: _ctx.lang,
                  class: "justify-self-end"
                }, null, 8, ["ba", "immobilie", "lang"]),
                _createVNode(_component_oneto_five_image_div, {
                  ba: _ctx.ba,
                  immobilie: _ctx.immobilie,
                  fragesPath: "tng-be-flaechen.zuwegung-mast-tab.gefaelle.gefaelle-bilder",
                  lang: _ctx.lang,
                  class: "col-span-8"
                }, null, 8, ["ba", "immobilie", "lang"]),
                _createVNode(_component_is_vorhanden_char_and_label, {
                  ba: _ctx.ba,
                  fragesPath: "tng-be-flaechen.zuwegung-mast-tab.ausholzung.ausholzung-erforderlich",
                  label: "Ausholzung erforderlich",
                  class: "col-span-2"
                }, null, 8, ["ba"]),
                _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.useIdentifierFrageFinder(_ctx.ba, 'tng-be-flaechen.zuwegung-mast-tab.ausholzung.ausholzung-beschreibung')?.['eingabeText']), 1),
                _hoisted_14,
                _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.getAuswahlLabel(_ctx.ba, 'tng-be-flaechen.zuwegung-mast-tab.ausholzung.ausholzung-bereich')), 1),
                _createVNode(_component_bewertung_chip, {
                  fragesPath: "tng-be-flaechen.zuwegung-mast-tab.ausholzung.ausholzung-bewertung",
                  ba: _ctx.ba,
                  immobilie: _ctx.immobilie,
                  lang: _ctx.lang,
                  class: "justify-self-end"
                }, null, 8, ["ba", "immobilie", "lang"]),
                _createVNode(_component_oneto_five_image_div, {
                  ba: _ctx.ba,
                  immobilie: _ctx.immobilie,
                  fragesPath: "tng-be-flaechen.zuwegung-mast-tab.ausholzung.ausholzung-bilder",
                  lang: _ctx.lang,
                  class: "col-span-8"
                }, null, 8, ["ba", "immobilie", "lang"]),
                _createVNode(_component_is_vorhanden_char_and_label, {
                  ba: _ctx.ba,
                  fragesPath: "tng-be-flaechen.zuwegung-mast-tab.rodung.rodung-erforderlich",
                  label: "Rodung erforderlich",
                  class: "col-span-2"
                }, null, 8, ["ba"]),
                _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.useIdentifierFrageFinder(_ctx.ba, 'tng-be-flaechen.zuwegung-mast-tab.rodung.rodung-beschreibung')?.['eingabeText']), 1),
                _hoisted_17,
                _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.useIdentifierFrageFinder(_ctx.ba, 'tng-be-flaechen.zuwegung-mast-tab.rodung.anzahl-baeume')?.['eingabeText']), 1),
                _createVNode(_component_bewertung_chip, {
                  fragesPath: "tng-be-flaechen.zuwegung-mast-tab.rodung.rodung-bewertung",
                  ba: _ctx.ba,
                  immobilie: _ctx.immobilie,
                  lang: _ctx.lang,
                  class: "justify-self-end"
                }, null, 8, ["ba", "immobilie", "lang"]),
                _createVNode(_component_oneto_five_image_div, {
                  ba: _ctx.ba,
                  immobilie: _ctx.immobilie,
                  fragesPath: "tng-be-flaechen.zuwegung-mast-tab.rodung.rodung-bilder",
                  lang: _ctx.lang,
                  class: "col-span-8"
                }, null, 8, ["ba", "immobilie", "lang"]),
                _hoisted_19,
                _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.useIdentifierFrageFinder(_ctx.ba,'tng-be-flaechen.zuwegung-mast-tab.zuwegung-wegeart.zuwegung-wegeart-beschreibung')?.getSelectedAuswahlLabelsString()), 1),
                _createVNode(_component_bewertung_chip, {
                  fragesPath: "tng-be-flaechen.zuwegung-mast-tab.zuwegung-wegeart.zuwegung-wegeart-bewertung",
                  ba: _ctx.ba,
                  immobilie: _ctx.immobilie,
                  lang: _ctx.lang,
                  class: "justify-self-end"
                }, null, 8, ["ba", "immobilie", "lang"]),
                _hoisted_21,
                _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.useIdentifierFrageFinder(_ctx.ba, 'tng-be-flaechen.zuwegung-mast-tab.zuwegung-laenge.zuwegung-laenge-m')?.['eingabeText'] 
                  ? _ctx.useIdentifierFrageFinder(_ctx.ba, 'tng-be-flaechen.zuwegung-mast-tab.zuwegung-laenge.zuwegung-laenge-m')?.['eingabeText'] + " m" 
                  : "-"), 1),
                _createVNode(_component_bewertung_chip, {
                  fragesPath: "tng-be-flaechen.zuwegung-mast-tab.zuwegung-laenge.zuwegung-laenge-bewertung",
                  ba: _ctx.ba,
                  immobilie: _ctx.immobilie,
                  lang: _ctx.lang,
                  class: "justify-self-end"
                }, null, 8, ["ba", "immobilie", "lang"]),
                _hoisted_23,
                _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.useIdentifierFrageFinder(_ctx.ba, 'tng-be-flaechen.zuwegung-mast-tab.zuwegung.zuwegung-breitevonbis')?.['eingabeText'] 
                  ? _ctx.useIdentifierFrageFinder(_ctx.ba, 'tng-be-flaechen.zuwegung-mast-tab.zuwegung.zuwegung-breitevonbis')?.['eingabeText'] + " m" 
                  : "-"), 1),
                _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.useIdentifierFrageFinder(_ctx.ba,'tng-be-flaechen.zuwegung-mast-tab.zuwegung.zuwegung-breite-beschreibung')?.['eingabeText']), 1),
                _createVNode(_component_bewertung_chip, {
                  fragesPath: "tng-be-flaechen.zuwegung-mast-tab.zuwegung.zuwegung-breite-bewertung",
                  ba: _ctx.ba,
                  immobilie: _ctx.immobilie,
                  lang: _ctx.lang,
                  class: "justify-self-end"
                }, null, 8, ["ba", "immobilie", "lang"]),
                _hoisted_26,
                _hoisted_27,
                _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.useIdentifierFrageFinder(_ctx.ba, 'tng-be-flaechen.zuwegung-mast-tab.zuwegung-hoehe.zuwegung-hoehe-start')?.['eingabeText'] 
                  ? _ctx.useIdentifierFrageFinder(_ctx.ba, 'tng-be-flaechen.zuwegung-mast-tab.zuwegung-hoehe.zuwegung-hoehe-start')?.['eingabeText'] + " m" 
                  : "-"), 1),
                _hoisted_29,
                _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.useIdentifierFrageFinder(_ctx.ba, 'tng-be-flaechen.zuwegung-mast-tab.zuwegung-hoehe.zuwegung-hoehe-ende')?.['eingabeText'] 
                  ? _ctx.useIdentifierFrageFinder(_ctx.ba, 'tng-be-flaechen.zuwegung-mast-tab.zuwegung-hoehe.zuwegung-hoehe-ende')?.['eingabeText'] + " m" 
                  : "-"), 1),
                _hoisted_31,
                _hoisted_32,
                _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.useIdentifierFrageFinder(_ctx.ba, 'tng-be-flaechen.zuwegung-mast-tab.zuwegung-hoehe.zuwegung-hoehenunterschied')?.['eingabeText'] 
                  ? _ctx.useIdentifierFrageFinder(_ctx.ba, 'tng-be-flaechen.zuwegung-mast-tab.zuwegung-hoehe.zuwegung-hoehenunterschied')?.['eingabeText'] + " m" 
                  : "-"), 1),
                _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.useIdentifierFrageFinder(_ctx.ba,'tng-be-flaechen.zuwegung-mast-tab.zuwegung-hoehe.zuwegung-hoehe-beschreibung')?.['eingabeText']), 1),
                _createVNode(_component_bewertung_chip, {
                  fragesPath: "tng-be-flaechen.zuwegung-mast-tab.zuwegung-hoehe.zuwegung-hoehe-bewertung",
                  ba: _ctx.ba,
                  immobilie: _ctx.immobilie,
                  lang: _ctx.lang,
                  class: "justify-self-end"
                }, null, 8, ["ba", "immobilie", "lang"])
              ])
            ]),
            _createVNode(_component_be_footer, {
              ba: _ctx.ba,
              immobilie: _ctx.immobilie,
              lang: _ctx.lang
            }, null, 8, ["ba", "immobilie", "lang"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["pdf-key"]),
    _createVNode(_component_pdf_a4_page, {
      "no-margin": "",
      "pdf-key": _ctx.lang
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("div", _hoisted_36, [
            _createVNode(_component_tng_header, {
              ba: _ctx.ba,
              immobilie: _ctx.immobilie,
              lang: _ctx.lang
            }, null, 8, ["ba", "immobilie", "lang"]),
            _hoisted_37,
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("div", _hoisted_39, [
                _hoisted_40,
                _hoisted_41,
                _hoisted_42,
                _hoisted_43,
                _hoisted_44,
                _createVNode(_component_is_vorhanden_char_and_label, {
                  ba: _ctx.ba,
                  fragesPath: "tng-be-flaechen.zuwegung-mast-tab.beschraenkung.beschraenkung-vorhanden",
                  label: "Beschränkung vorhanden",
                  class: "col-span-2"
                }, null, 8, ["ba"]),
                _hoisted_45,
                _createElementVNode("div", _hoisted_46, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.useIdentifierFrageFinder(
                  _ctx.ba,
                  'tng-be-flaechen.zuwegung-mast-tab.beschraenkung.beschraenkung-art'
                )?.getSelectedAuswahlLabels(), (v, key) => {
                    return (_openBlock(), _createElementBlock("ul", {
                      key: key,
                      class: ""
                    }, [
                      (_openBlock(), _createElementBlock("li", {
                        key: key,
                        class: "text-xs text-gray-500"
                      }, _toDisplayString(v.de), 1))
                    ]))
                  }), 128))
                ]),
                _hoisted_47,
                _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.useIdentifierFrageFinder(_ctx.ba, 'tng-be-flaechen.zuwegung-mast-tab.beschraenkung.beschraenkung-gewicht-wert')?.['eingabeText'] 
                  ? _ctx.useIdentifierFrageFinder(_ctx.ba, 'tng-be-flaechen.zuwegung-mast-tab.beschraenkung.beschraenkung-gewicht-wert')?.['eingabeText'] + " to" 
                  : "-"), 1),
                _createVNode(_component_bewertung_chip, {
                  fragesPath: "tng-be-flaechen.zuwegung-mast-tab.beschraenkung.beschraenkung-gewicht-bewertung",
                  ba: _ctx.ba,
                  immobilie: _ctx.immobilie,
                  lang: _ctx.lang,
                  class: "justify-self-end"
                }, null, 8, ["ba", "immobilie", "lang"]),
                _hoisted_49,
                _hoisted_50,
                _createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.useIdentifierFrageFinder(_ctx.ba, 'tng-be-flaechen.zuwegung-mast-tab.beschraenkung.beschraenkung-hoehe-wert')?.['eingabeText'] 
                  ? _ctx.useIdentifierFrageFinder(_ctx.ba, 'tng-be-flaechen.zuwegung-mast-tab.beschraenkung.beschraenkung-hoehe-wert')?.['eingabeText'] + " m" 
                  : "-"), 1),
                _createVNode(_component_bewertung_chip, {
                  fragesPath: "tng-be-flaechen.zuwegung-mast-tab.beschraenkung.beschraenkung-hoehe-bewertung",
                  ba: _ctx.ba,
                  immobilie: _ctx.immobilie,
                  lang: _ctx.lang,
                  class: "justify-self-end"
                }, null, 8, ["ba", "immobilie", "lang"]),
                _createVNode(_component_oneto_five_image_div, {
                  ba: _ctx.ba,
                  immobilie: _ctx.immobilie,
                  fragesPath: "tng-be-flaechen.zuwegung-mast-tab.beschraenkung.bilder-beschraenkung",
                  lang: _ctx.lang,
                  class: "col-span-8"
                }, null, 8, ["ba", "immobilie", "lang"]),
                _hoisted_52,
                _createElementVNode("div", _hoisted_53, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.useIdentifierFrageFinder(
                  _ctx.ba,
                  'tng-be-flaechen.zuwegung-mast-tab.beschaffenheit.beschaffenheit'
                )?.getSelectedAuswahlLabels(), (v, key) => {
                    return (_openBlock(), _createElementBlock("ul", {
                      key: key,
                      class: ""
                    }, [
                      (_openBlock(), _createElementBlock("li", {
                        key: key,
                        class: "text-xs text-gray-500"
                      }, _toDisplayString(v.de), 1))
                    ]))
                  }), 128))
                ]),
                _createVNode(_component_bewertung_chip, {
                  fragesPath: "tng-be-flaechen.zuwegung-mast-tab.beschaffenheit.beschaffenheit-bewertung",
                  ba: _ctx.ba,
                  immobilie: _ctx.immobilie,
                  lang: _ctx.lang,
                  class: "justify-self-end"
                }, null, 8, ["ba", "immobilie", "lang"]),
                _hoisted_54,
                _createElementVNode("div", _hoisted_55, _toDisplayString(_ctx.useIdentifierFrageFinder(_ctx.ba, 'tng-be-flaechen.zuwegung-mast-tab.ringverkehr.ringverkehr-beschreibung')?.['eingabeText']), 1),
                _hoisted_56,
                _createElementVNode("div", _hoisted_57, _toDisplayString(_ctx.useIdentifierFrageFinder(_ctx.ba,'tng-be-flaechen.zuwegung-mast-tab.ringverkehr.ringverkehr-moeglich')?.getSelectedAuswahlLabelsString()), 1),
                _createVNode(_component_bewertung_chip, {
                  fragesPath: "tng-be-flaechen.zuwegung-mast-tab.ringverkehr.ringverkehr-bewertung",
                  ba: _ctx.ba,
                  immobilie: _ctx.immobilie,
                  lang: _ctx.lang,
                  class: "justify-self-end"
                }, null, 8, ["ba", "immobilie", "lang"]),
                _hoisted_58,
                _createElementVNode("div", _hoisted_59, [
                  _createElementVNode("span", _hoisted_60, _toDisplayString(_ctx.useIdentifierFrageFinder(_ctx.ba, 'tng-be-flaechen.zuwegung-mast-tab.ausweichflaechen.ausweichflaechen')?.getSelectedAuswahlLabelsString()), 1)
                ]),
                _createElementVNode("div", _hoisted_61, _toDisplayString(_ctx.useIdentifierFrageFinder(_ctx.ba, 'tng-be-flaechen.zuwegung-mast-tab.ausweichflaechen.ausweichflaechen-beschreibung')?.['eingabeText']), 1),
                _createVNode(_component_bewertung_chip, {
                  fragesPath: "tng-be-flaechen.zuwegung-mast-tab.ausweichflaechen.ausweichflaechen-bewertung",
                  ba: _ctx.ba,
                  immobilie: _ctx.immobilie,
                  lang: _ctx.lang,
                  class: "justify-self-end"
                }, null, 8, ["ba", "immobilie", "lang"]),
                _hoisted_62,
                _createElementVNode("div", _hoisted_63, _toDisplayString(_ctx.useIdentifierFrageFinder(_ctx.ba, 'tng-be-flaechen.zuwegung-mast-tab.alternative-zufahrt.alternative-zufahrt-beschreibung')?.['eingabeText']), 1),
                _createElementVNode("div", _hoisted_64, _toDisplayString(_ctx.useIdentifierFrageFinder(_ctx.ba,'tng-be-flaechen.zuwegung-mast-tab.alternative-zufahrt.alternative-zufahrt')?.getSelectedAuswahlLabelsString()), 1),
                _createVNode(_component_bewertung_chip, {
                  fragesPath: "tng-be-flaechen.zuwegung-mast-tab.alternative-zufahrt.alternative-zufahrt-bewertung",
                  ba: _ctx.ba,
                  immobilie: _ctx.immobilie,
                  lang: _ctx.lang,
                  class: "justify-self-end"
                }, null, 8, ["ba", "immobilie", "lang"]),
                _createVNode(_component_is_vorhanden_char_and_label, {
                  ba: _ctx.ba,
                  fragesPath: "tng-be-flaechen.zuwegung-mast-tab.sonstiges.sonstiges-vorhanden",
                  label: "Sonstiges",
                  class: "col-span-2"
                }, null, 8, ["ba"]),
                _createElementVNode("div", _hoisted_65, _toDisplayString(_ctx.useIdentifierFrageFinder(_ctx.ba, 'tng-be-flaechen.zuwegung-mast-tab.sonstiges.sonstiges')?.['eingabeText']), 1),
                _createVNode(_component_bewertung_chip, {
                  fragesPath: "tng-be-flaechen.zuwegung-mast-tab.sonstiges.sonstiges-bewertung",
                  ba: _ctx.ba,
                  immobilie: _ctx.immobilie,
                  lang: _ctx.lang,
                  class: "justify-self-end"
                }, null, 8, ["ba", "immobilie", "lang"])
              ]),
              _hoisted_66,
              ((_ctx.getBauwerke(_ctx.ba)|| []) .length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                    _hoisted_68,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getBauwerke(_ctx.ba), (bauwerk, key) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: key,
                        class: "ml-2 mt-2 grid grid-cols-8 justify-items-stretch items-center",
                        style: {"border-style":"solid","border-color":"var(--white100) var(--white100) var(--white100) rgb(216, 215, 26)","border-radius":"5px"}
                      }, [
                        _hoisted_69,
                        _createElementVNode("div", _hoisted_70, _toDisplayString(bauwerk['freitext']), 1),
                        _hoisted_71,
                        _createElementVNode("div", _hoisted_72, _toDisplayString(bauwerk['tragfaehig']), 1),
                        _createElementVNode("div", _hoisted_73, [
                          ('plus' === bauwerk['bauwerk-bewertung'])
                            ? (_openBlock(), _createBlock(_component_PdfChip, {
                                key: 0,
                                color: "green",
                                "mangel-amount-mode": "",
                                value: "1",
                                "pdf-mode": ""
                              }))
                            : _createCommentVNode("", true),
                          ('o' === bauwerk['bauwerk-bewertung'])
                            ? (_openBlock(), _createBlock(_component_PdfChip, {
                                key: 1,
                                color: "blue",
                                "mangel-amount-mode": "",
                                value: "1",
                                "pdf-mode": ""
                              }))
                            : _createCommentVNode("", true),
                          ('minus' === bauwerk['bauwerk-bewertung'])
                            ? (_openBlock(), _createBlock(_component_PdfChip, {
                                key: 2,
                                color: "yellow",
                                "mangel-amount-mode": "",
                                value: "1",
                                "pdf-mode": ""
                              }))
                            : _createCommentVNode("", true),
                          ('x' === bauwerk['bauwerk-bewertung'])
                            ? (_openBlock(), _createBlock(_component_PdfChip, {
                                key: 3,
                                color: "red",
                                "mangel-amount-mode": "",
                                value: "1",
                                "pdf-mode": ""
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _hoisted_74,
                        _createElementVNode("div", _hoisted_75, _toDisplayString(bauwerk['beschreibung']), 1),
                        _createVNode(_component_oneto_five_image_div, {
                          ba: _ctx.ba,
                          immobilie: _ctx.immobilie,
                          lang: _ctx.lang,
                          imageObjects: bauwerk['bild'],
                          class: "ml-2 col-span-8"
                        }, null, 8, ["ba", "immobilie", "lang", "imageObjects"])
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_76, _hoisted_78))
            ]),
            _createVNode(_component_be_footer, {
              ba: _ctx.ba,
              immobilie: _ctx.immobilie,
              lang: _ctx.lang
            }, null, 8, ["ba", "immobilie", "lang"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["pdf-key"]),
    _createVNode(_component_pdf_a_4_page, {
      "no-margin": "",
      "pdf-key": _ctx.lang
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_79, [
          _createElementVNode("div", _hoisted_80, [
            _createVNode(_component_tng_header, {
              ba: _ctx.ba,
              immobilie: _ctx.immobilie,
              lang: _ctx.lang
            }, null, 8, ["ba", "immobilie", "lang"]),
            _hoisted_81,
            _createElementVNode("div", _hoisted_82, [
              _hoisted_83,
              ((_ctx.getGraben(_ctx.ba) || []).length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                    _hoisted_85,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getGraben(_ctx.ba), (graben, key) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: key,
                        class: "ml-2 grid grid-cols-8 justify-items-stretch items-center",
                        style: {"border-style":"solid","border-color":"var(--white100) var(--white100) var(--white100) rgb(216, 215, 26)","border-radius":"5px"}
                      }, [
                        _hoisted_86,
                        _createElementVNode("div", _hoisted_87, _toDisplayString(graben['art'].replace(/-/g, ' ')), 1),
                        _createElementVNode("div", _hoisted_88, _toDisplayString(graben['graben-beschreibung']), 1),
                        _createElementVNode("div", _hoisted_89, [
                          ('plus' === graben['graben-bewertung'])
                            ? (_openBlock(), _createBlock(_component_PdfChip, {
                                key: 0,
                                color: "green",
                                "mangel-amount-mode": "",
                                value: "1",
                                "pdf-mode": ""
                              }))
                            : _createCommentVNode("", true),
                          ('o' === graben['graben-bewertung'])
                            ? (_openBlock(), _createBlock(_component_PdfChip, {
                                key: 1,
                                color: "blue",
                                "mangel-amount-mode": "",
                                value: "1",
                                "pdf-mode": ""
                              }))
                            : _createCommentVNode("", true),
                          ('minus' === graben['graben-bewertung'])
                            ? (_openBlock(), _createBlock(_component_PdfChip, {
                                key: 2,
                                color: "yellow",
                                "mangel-amount-mode": "",
                                value: "1",
                                "pdf-mode": ""
                              }))
                            : _createCommentVNode("", true),
                          ('x' === graben['graben-bewertung'])
                            ? (_openBlock(), _createBlock(_component_PdfChip, {
                                key: 3,
                                color: "red",
                                "mangel-amount-mode": "",
                                value: "1",
                                "pdf-mode": ""
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _hoisted_90,
                        _createElementVNode("div", _hoisted_91, _toDisplayString(graben['abstand'] ==null ? '': graben['abstand'] + " m"), 1),
                        _createElementVNode("div", _hoisted_92, _toDisplayString(graben['graben-typ']), 1),
                        _createVNode(_component_oneto_five_image_div, {
                          ba: _ctx.ba,
                          immobilie: _ctx.immobilie,
                          lang: _ctx.lang,
                          imageObjects: graben['graben-bilder'],
                          class: "ml-2 col-span-8"
                        }, null, 8, ["ba", "immobilie", "lang", "imageObjects"])
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_93, _hoisted_95))
            ]),
            _createVNode(_component_be_footer, {
              ba: _ctx.ba,
              immobilie: _ctx.immobilie,
              lang: _ctx.lang
            }, null, 8, ["ba", "immobilie", "lang"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["pdf-key"]),
    _createVNode(_component_Oekologie, {
      ba: _ctx.ba,
      immobilie: _ctx.immobilie,
      lang: _ctx.lang,
      oekologie: _ctx.ba.findFragenblockByRelativePath('zuwegung-mast-tab.oekologie-group')!,
      "bread-crumb": "Zuwegung Mast > Ökologie",
      tab: "Zuwegung"
    }, null, 8, ["ba", "immobilie", "lang", "oekologie"])
  ], 64))
}